import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-9EBVYWMLFY';

// Track page views on route change
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    }
  }, [location]);
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Pre-defined event trackers for common actions
export const Analytics = {
  // Track job views
  trackJobView: (jobTitle, jobId) => {
    trackEvent('view_job', 'Jobs', jobTitle, jobId);
  },

  // Track job applications
  trackJobApplication: (jobTitle) => {
    trackEvent('apply_job', 'Jobs', jobTitle);
  },

  // Track resume submissions
  trackResumeSubmission: (position) => {
    trackEvent('submit_resume', 'Resumes', position);
  },

  // Track contact form submissions
  trackContactSubmission: () => {
    trackEvent('submit_contact', 'Contact', 'Contact Form');
  },

  // Track blog views
  trackBlogView: (blogTitle, blogSlug) => {
    trackEvent('view_blog', 'Blogs', blogTitle);
  },

  // Track CTA clicks
  trackCTAClick: (ctaName, pageName) => {
    trackEvent('click_cta', 'CTA', `${ctaName} on ${pageName}`);
  },

  // Track sector interest
  trackSectorView: (sectorName) => {
    trackEvent('view_sector', 'Sectors', sectorName);
  }
};

export default usePageTracking;
